import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://qzzuxieznqawppiduqwc.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY || 'sb_publishable_giBTWCx5oCEEcx2u_cHu3w_e5x6r13C';

export const supabase = createClient(supabaseUrl, supabaseKey);
